import ApiService from "@/common/api.service";
import { TERMINAL, ERROR } from "./actions.type";
import { Terminals } from '@/firebase'

const state = {
  items: null,
  last: null
};
const mutations = {
  [TERMINAL.SET](state, items) {
    state.items = items;
  },
  [TERMINAL.SET_LAST](state, items) {
    state.last = items;
  }
};

const getters = {
  terminals(state) {
    return state.items;
  },
  lastTerminal(state) {
    return state.last;
  }
};

const actions = {
  async [TERMINAL.FETCH](context, userId) {
    const snapshot = await Terminals.where('userId', '==', userId).get()
      .catch(e => {
        context.commit(ERROR.SET, e);
      });
    if (snapshot.empty) {
      console.log('No matching documents.');
      return;
    }
    const data = []
    snapshot.forEach(doc => {
      // console.log(doc.id, '=>', doc.data());
      data.push(doc.data())
    });
    context.commit(TERMINAL.SET, data);
    return data
  },
  async [TERMINAL.GET](context, accountId) {
    const snapshot = await Terminals.where('accountId', '==', accountId).get()
      .catch(e => {
        context.commit(ERROR.SET, e);
      });
    if (snapshot.empty) {
      console.log('No matching documents.');
      return;
    }
    const data = []
    snapshot.forEach(doc => {
      data.push(doc.data())
    });
    // context.commit(TERMINAL.SET_LAST, data);
    return data
  },
  async [TERMINAL.CREATE](context, schema) {
    const res = Terminals.add(schema)
      .catch(e => {
        context.commit(ERROR.SET, e);
      });
    return res
  },
  async [TERMINAL.EDIT](context, schema) {
    const res = Terminals.doc(schema.id).update(schema)
      .catch(e => {
        context.commit(ERROR.SET, e);
      });
    return res
  },

  async [TERMINAL.DEL](context, schema) {
    const res = Terminals.doc(schema.id).delete()
      .catch(e => {
        context.commit(ERROR.SET, e);
      });
    return res
  },
  [TERMINAL.TELEGRAM_DECODE](context, schema) {
    return new Promise((resolve, reject) => {
      // set header to authorize
      ApiService.setHeader().then(() => {
        ApiService.post("terminals/telegram/auth", schema)
          .then(result => {
            context.dispatch(TERMINAL.FETCH);
            resolve(result);
          })
          .catch(e => {
            context.commit(ERROR.SET, e);
            reject(e);
          });
      });
    });
  },
};

export default {
  state,
  actions,
  mutations,
  getters
};
